import type { PillVariant } from '../types';

/**
 * Abzeichen einer Reservierungsgruppe. Geteilt von Tabelle und mobiler Kartenliste, damit eine
 * Teilstornierung nicht je nach Fenstergröße anders heißt.
 *
 * `Active` bekommt bewusst kein Abzeichen: es ist der Normalfall und stünde sonst über jeder
 * Gruppe. Gezeigt wird nur, was davon abweicht.
 */
export const RESERVATION_STATUS_PILL: Record<
  'PartiallyCancelled' | 'Cancelled',
  { label: string; variant: PillVariant }
> = {
  PartiallyCancelled: { label: 'Teilstorno', variant: 'warning' },
  Cancelled: { label: 'Storniert', variant: 'stop' },
};
